module.exports = __webpack_public_path__ + "media/video_demo.09dc01cf.mp4";